import {HeaderMall9} from '../../../../../publicComponent/Header';
import Navigator from '../../../../../publicComponent/h5/Navigator';
import Button from '../../../../../publicComponent/Button';
import MyBookingContext, {MyBookingController, useMyBookingContext} from "../../../../../reducer/moduleReducer/my/myBooking";
import {useEffect} from "react";
import Pagination from "../../../../../publicComponent/Pagination";
import Buffer from "../../../../../publicComponent/Buffer";
import {getI18n, useTranslation} from "react-i18next";
import TabsMall9 from "../../../../../publicComponent/Tabs/TabMall9";
import dayjs from 'dayjs'

function BookingCard({ data, gotoBookingDetail }) {
  const { cancelBooking, getStatus,transformAddress } = MyBookingController();
  const { t } = useTranslation();
  const reserveInfo = data.reserveInfo || {};
  const lang = getI18n().language;
  
  return (
    <>
      <div className="mdmax:hidden border-[#eee] border bg-[#fbfbfb] p-[15px] mb-[16px]">
        <div className="mb-[16px] flex text-[#666]">
          <p className="mr-[40px] text-[#666] w-[160px]">{data.createTime}</p>
          <p className="text-[#666]">{t('订单号：')} {data.reserveNo}</p>
        </div>
        <div className="grid grid-cols-12 gap-3 items-center">
          <div className="col-span-6 flex">
            <div className="flex-none w-[100px] h-[100px] mr-[20px] bg-white rounded-[5px] overflow-hidden">
              <img src={reserveInfo?.mainPicView} style={{ width: '100%', height: '100%' }}/>
            </div>
            <div className="mt-[5px]">
              <p className="font-bold text-[15px]">{lang === 'en'? reserveInfo?.titleEn:reserveInfo?.title}</p>
              <p className="text-[#666] my-[5px]">{t('店铺名称')}：{lang=== 'en'?reserveInfo?.shopInfo?.shopNameEn:reserveInfo?.shopInfo?.shopName}</p>
              <p className="text-[#666]">{t('店铺地址')}：{transformAddress(reserveInfo?.shopInfo?.areaname)}&nbsp;{lang=== 'en'?reserveInfo?.shopInfo?.addressEn:reserveInfo?.shopInfo?.address}</p>
            </div>
          </div>
          <div className="col-span-2 text-center mb-[20px] text-[14px]">{data.reserveDate} {data.reserveTime}</div>
          <div className="col-span-1 text-center mb-[20px] text-[14px]">{t(getStatus(data.status))}</div>
          <div className="col-span-3 text-center mb-[20px]">
            {
              data.status === '0' && dayjs(data.reserveDate + ' ' + data.reserveTime).isAfter(Date.now()) &&
              <Button onClick={() => cancelBooking(data)}
                      className="px-[12px] py-[5px] text-[13px] border border-[#d4d4d4]
                                 bg-white rounded-[5px] mr-[8px]">{t('取消')}</Button>
            }
            <Button onClick={() => gotoBookingDetail(data)}
                    className="px-[12px] py-[5px] text-[13px] border border-[#d4d4d4]
                               rounded-[5px] bg-[#333] border-[#333] text-white">
              {t('查看详情')}
            </Button>
          </div>
        </div>
      </div>
      
      <div className="md:hidden">
        <div className="py-[8px] flex items-center justify-between px-[15px]">
          <div className="flex items-center">
            <p className="font-bold mr-[8px] text-[14px]">{t(getStatus(data.status))}</p>
            <p className="text-[#999] text-[12px] mt-[2px]">{t('订单号：')} {data.reserveNo}</p>
          </div>
          {
            data.status === '0' && dayjs(data.reserveDate + ' ' + data.reserveTime).isAfter(Date.now()) &&
            <Button onClick={() => cancelBooking(data)}
                    className="border-[1px] py-[4px] px-[10px] rounded-full
                               text-[12px] bg-white border-[#d4d4d4]">{t('取消')}</Button>
          }
        </div>
        
        <div className="flex items-center p-[15px] bg-white "
             onClick={() => gotoBookingDetail(data)}>
          <div className="flex-none w-[85px] mr-[15px] overflow-hidden rounded-[5px]">
            <img src={reserveInfo?.mainPicView} style={{ width: '100%', height: '100%' }}/>
          </div>
          <div className="flex flex-col justify-between">
            <p className="text-[12px]">{lang === 'en'? reserveInfo?.titleEn:reserveInfo?.title}</p>
            <p className="text-[12px] my-[5px]">{t('店铺')}：{lang=== 'en'?reserveInfo?.shopInfo?.shopNameEn:reserveInfo?.shopInfo?.shopName}</p>
            <p className="text-[12px]">{t('店铺地址')}：{transformAddress(reserveInfo?.shopInfo?.areaname)}&nbsp;{lang=== 'en'?reserveInfo?.shopInfo?.addressEn:reserveInfo?.shopInfo?.address}</p>
          </div>
        </div>
        
        <div className="flex items-center justify-between p-[15px] bg-white border-bottom-1px border-[#eee] ">
          <div>
            <span>{t('预约时间')}</span>
            <span className="font-bold ml-[10px]">{data.reserveDate} {data.reserveTime}</span>
          </div>
          <p className="border rounded-full w-[35px] h-[35px] flex items-center justify-center border-[#333]">
            <i className="iconfont icon-mobile"></i>
          </p>
        </div>
      </div>
    </>
  );
}

function THead() {
  const { t } = useTranslation();
  
  return (
    <div className="grid grid-cols-12 gap-3 px-[18px] py-[12px] mdmax:hidden">
      <p className="text-[14px] font-bold col-span-6"></p>
      <p className="text-[14px] font-bold col-span-2 text-center">{t('预约时间')}</p>
      <p className="text-[14px] font-bold col-span-1 text-center">{t('预约状态')}</p>
      <p className="text-[14px] font-bold col-span-3 text-center">{t('操作')}</p>
    </div>
  );
}

function MyBookingWrap() {
  const { getBookingList, gotoBookingDetail, setTabsActive } = MyBookingController();
  const { state } = useMyBookingContext();
  const { bookingList, total, query, statusTabs, tabActive, loading } = state;
  const { t } = useTranslation();
  
  useEffect(() => {
    getBookingList();
  }, []);
  
  const onPageChange = (page) => {
    getBookingList({ page });
  };
  
  return (
    <>
      <Navigator.container className="container-center md:pb-[53px]">
        <h1 className="font-bold py-[30px] text-[24px] pb-[12px] mdmax:hidden">{t('我的预约')}</h1>
        <TabsMall9 fixed
                   tabs={statusTabs}
                   active={tabActive}
                   tabsActiveColor="#ECBC40"
                   style={{ marginBottom: 0, borderBottom: 0 }}
                   onChange={setTabsActive}/>
        <div className="relative mdmax:pt-[40px] mdmax:bg-[#f4f4f6]">
          <Buffer.Loading loading={loading}/>
          {
            bookingList.records && bookingList.records.length > 0
              ? <>
                <THead/>
                {
                  bookingList.records.map((item, i) => (
                    <BookingCard gotoBookingDetail={gotoBookingDetail} data={item} key={i}/>
                  ))
                }
                
                <Pagination total={total}
                            current={query.page}
                            onChange={onPageChange}
                            className="md:mb-[100px]"/>
              </>
              : <Buffer.Empty content={t('暂无相关消息')}/>
            
          }
        </div>
      </Navigator.container>
      
      {/*<FixedBar className="text-center">*/}
      {/*  <Button className="w-[80%] rounded-[10px] py-[8px] bg-white border border-[#666] text-[14px]">新增预约</Button>*/}
      {/*</FixedBar>*/}
    </>
  );
}

export default function MyBooking() {
  return (
    <>
      <HeaderMall9/>
      <Navigator title="我的预约" goback noBorder/>
      <MyBookingContext>
        <MyBookingWrap/>
      </MyBookingContext>
    </>
  );
}
